import { render, staticRenderFns } from "./IcoRocket.vue?vue&type=template&id=2dd47154"
import script from "./IcoRocket.vue?vue&type=script&lang=js"
export * from "./IcoRocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports